import type { NavBarAuthSourceConfig } from './useNavBarAuthHandlers.types';

import * as routes from 'constants/Routes';

export enum NAV_BAR_AUTH_SOURCES {
  SIGN_UP = 'Sign Up',
  LOGIN = 'Login'
}

export const NAV_BAR_AUTH_SOURCES_CONFIGS: {
  [key in NAV_BAR_AUTH_SOURCES]: NavBarAuthSourceConfig;
} = {
  [NAV_BAR_AUTH_SOURCES.LOGIN]: {
    source: NAV_BAR_AUTH_SOURCES.LOGIN,
    route: routes.login
  },
  [NAV_BAR_AUTH_SOURCES.SIGN_UP]: {
    source: NAV_BAR_AUTH_SOURCES.SIGN_UP,
    route: routes.activate
  }
};
